import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import LogoComponent from '../subComponents/LogoComponent'
import PowerButton from '../subComponents/PowerButton'
import SocialIcons from '../subComponents/SocialIcons'
import { YinYang } from './AllSvgs'
import Intro from './Intro'
  ;


const MainContainer = styled.div`
background: ${props => props.theme.body};
width: 100vw;
height: 100vh;
overflow:hidden;

position: relative;

h2,h3,h4,h5,h6{
  font-family:'Karla', sans-serif 'Pacifico',cursive ;
  font-weight:500;
}
`

const Container = styled.div`
padding: 2rem;
`

const Contact = styled.a`
color: ${props => props.theme.text};
position: absolute;
top: 2rem;
right: calc(1rem + 2vw);
text-decoration: none;
z-index:1;
font-size: 14px;
font-family: 'Pacifico',cursive;

@media (max-width: 768px) {
    font-size: 12px;
    right: 0.5rem;
   
  }


`

const WORK = styled(NavLink)`

color: ${props => props.theme.text};
position: absolute;
top: 50%;
right: calc(1rem + 1.5vw);
transform: rotate(90deg) translate(-50%, -50%);
text-decoration: none;
z-index:1;
font-size: 15px;

@media (max-width: 768px) {
    font-size: 12px;
    right: 0.5rem;
    font-family:'Karla', sans-serif;
  }

`

const BottomBar = styled.div`
position: absolute;
bottom: 1rem;
left: 0;
right: 0;
width: 100%;

display: flex;
justify-content: space-evenly;


`

const ABOUT = styled(NavLink)`
color: ${props => props.click ? props.theme.body : props.theme.text};
text-decoration: none;
z-index:1;
 @media (max-width: 768px) {
    font-size: 12px;
    font-family:'Karla', sans-serif;
    color: ${props => props.theme.text};
  }
`
const SKILLS = styled(NavLink)`
color: ${props => props.theme.text};
text-decoration: none;
z-index:1;

@media (max-width: 768px) {
    font-size: 12px;
    font-family:'Karla', sans-serif;
  }
`

const rotate = keyframes`
from{
    transform: rotate(0);
}
to{
    transform: rotate(360deg);
}
`

const Center = styled.button`
position: absolute;
top: ${props => props.click ? '85%' : '50%'};
left: ${props => props.click ? '92%' : '50%'};
transform: translate(-50%,-50%);
border: none;
outline: none;
background-color: transparent;
cursor: pointer;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
transition: all 1s ease;

&>:first-child{
    animation: ${rotate} infinite 1.5s linear;
}

&>:last-child{
    display: ${props => props.click ? 'none' : 'inline-block'};
    padding-top: 1rem;
}

 @media (max-width: 768px) {
    top: ${props => props.click ? '87%' : '50%'};
    left: ${props => props.click ? '80%' : '50%'};

    &>:first-child {
      width: ${props => props.click ? 80 : 125}px;
      height: ${props => props.click ? 80 : 125}px;
      transition: all 1s ease;
      
    }
  }
`

const DarkDiv = styled.div`
position: absolute;
top: 0;
background-color: #000;
bottom: 0;
right: 50%;
width: ${props => props.click ? '50%' : '0%'};
height: ${props => props.click ? '100%' : '0%'};
z-index:1;
transition: height 0.5s ease, width 1s ease 0.5s;


`


const Main = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);
    toggleFullscreen();
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    }
  };

  return (
    <MainContainer>
      <DarkDiv click={click} />
      <Container>
        <PowerButton />
        <LogoComponent theme={click ? 'dark' : 'light'} />
        <SocialIcons theme={click ? 'dark' : 'light'} />
        <Center click={click}>
          <YinYang onClick={handleClick} width={click ? 120 : 200} height={click ? 120 : 200} fill='currentColor' />
          <span>click here</span>
        </Center>
        <Contact target="_blank" href="mailto:shreenathmessi10@gmail.com">
          <motion.h2
            initial={{ y: -200, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
            animate={{ y: 0, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <span style={{ marginRight: '1px' }}>Hire me..</span>
            <svg style={{ fill: 'currentcolor', verticalAlign: 'middle', width: '23' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z" />
            </svg>
          </motion.h2>
        </Contact>
        <WORK to="/project" click={+click}>
          <motion.h2
            initial={{ y: -200, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
            animate={{ y: 0, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Projects
          </motion.h2>
        </WORK>
        <BottomBar>
          <ABOUT to="/about" click={+click}>
            <motion.h2
              initial={{ y: 200, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
              animate={{ y: 0, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              About
            </motion.h2>
          </ABOUT>
          <SKILLS to="/skills">
            <motion.h2
              initial={{ y: 200, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
              animate={{ y: 0, transition: { type: 'spring', duration: 1.5, delay: 1 } }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              My Skills
            </motion.h2>
          </SKILLS>
        </BottomBar>
      </Container>
      {click ? <Intro click={click} /> : null}
    </MainContainer>
  )
}

export default Main
